import React, { useState } from 'react';
import { TextArea, Button } from '@scale/scaleui';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface WorkerTeamsListBuilderProps {
  name: string;
  existingValue?: string[];
  updateProperty: (arg: string[]) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const WorkerTeamsListBuilder: React.FC<WorkerTeamsListBuilderProps> = ({
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const [newTeam, setNewTeam] = useState<string>('');

  const addTeam = () => {
    if (newTeam.trim()) {
      const updatedTeams = [...existingValue, newTeam.trim()];
      updateProperty(updatedTeams);
      setNewTeam('');
    }
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      <div className="prose text-sm mb-4">
        Worker teams to assign static tasks. Teams will be prioritized in the order they are listed.
      </div>
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={existingValue}
        setElements={updateProperty}
        getKey={(team: string) => team}
        getTitle={(team: string) => team}
        restrictFields={true}
        getSchema={() => ({})}
      />

      <div className="flex mt-4">
        <TextArea
          className="flex-grow"
          placeholder="Enter worker team ID"
          value={newTeam}
          onChange={e => {
            const value = e.target.value;
            setNewTeam(value);
          }}
          id="new-team-input"
          rows={1}
        />
        <Button className="ml-4" onClick={addTeam}>
          Add Team
        </Button>
      </div>
    </div>
  );
};

export default WorkerTeamsListBuilder;
